module.exports = __webpack_public_path__ + "img/15.21695033.jpg";